/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Styled components for Corporate Page
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.3.1
 */

import styled from 'styled-components';

import { GlobalContainer } from '../../../components/common';
import { colors } from '../../../theme';
import { IAttrStyled } from '../../../types/globalTypes';

const CorporatePageContainerStyled = styled.div.attrs((props: IAttrStyled) => ({
    className: `corporate-page ${props.className}`,
}))<IAttrStyled>`
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;

    padding-bottom: 32px; // footer

    &.corporate-page_dashboard {
        background: ${colors.pageDashboardContainerBgColor};
    }

    &.corporate-page_products {
        padding-bottom: 0;
    }
`;

const CorporatePageStyled = styled(GlobalContainer)`
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;

    padding: 16px 40px 0 40px;
`;

export {
    CorporatePageContainerStyled,
    CorporatePageStyled,
};
